import React, { useEffect, useState } from 'react'
import { Flex, Grid, GridItem, Box } from '@chakra-ui/react'
import { CustomButton, NavBar, Sidebar } from '../../components'
import MyDiv from './default.style'
import { useNavigate } from 'react-router'
import { useAuth } from '../../hooks/useAuth'
import MeetingReminderPopup from '../../views/Meetings/MeetingReminderPopup/MeetingReminderPopup'
import { useMeetingReminder } from '../../hooks/useMeetingReminder'
import { usePushNotification } from '../../hooks/usePushNotification'
import { useModuleFilterReset } from '../../hooks/useModuleFilterReset'
import { baseUrl, ideaUrl } from '../../hooks/useFetch';
import { useResignationNotification } from '../../hooks/useResignationNotification'
import ResignationNotificationPopup from '../../views/ReleaseEmployee/Resignation/ResignationNotificationPopup/ResignationNotificationPopup'
import { useAssetNotification } from '../../hooks/useAssetNotification'
import AssetNotificationPopup from '../../views/Asset/AssetNotificationPopup/AssetNotificationPopup'

const AppLayout = (props: any) => {
  const { hasPermission, loginObj } = useAuth();
  const [isActive, setIsActive] = useState(() => {
    return sessionStorage.getItem('activePortal') || 'hrlense';
  });

  const [toggleSidebar, setToggleSidebar] = useState(false)
  const navigate = useNavigate();

  const { reminderMeeting, dismissReminder } = useMeetingReminder(loginObj?.token);
  const { notification: resignationNotification, dismissNotification: dismissResignationNotification } = useResignationNotification(loginObj?.token);
  const canSeeAssetSummary = hasPermission("Dashboard", "AllAssetSummary")
    || hasPermission("Dashboard", "BranchWiseAssetSummary")
    || hasPermission("Assets", "ViewAllBranchStock")
    || hasPermission("Assets", "ViewOwnBranchStock");
  const { assetNotification, dismissAssetNotification } = useAssetNotification(loginObj?.token, canSeeAssetSummary);

  useModuleFilterReset();
  const handleSidePanel = () => {
    setToggleSidebar(!toggleSidebar)
  }


  const handleToggle = (type: string) => {
    setIsActive(type);
    sessionStorage.setItem('activePortal', type);

    if (type === 'hrlense') {
      navigate('/dashboard');
    } else if (type === 'Recruitment') {
      navigate('/recruitement-dashboard');
    } else if (type === 'consumer') {
      navigate('/bookDemo_user');
    }
  };

  const openIdeaManagement = async () => {

    if (loginObj?.token != null) {
      const response = await fetch(`${baseUrl}sso/generate-token`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${loginObj?.token}`
        }
      });


      const result = await response.json();

      if (result.success) {
        window.open(ideaUrl + result.url, "_blank");
      }
    }
  };

  useEffect(() => {
    sessionStorage.setItem('activePortal', isActive);
  }, [isActive]);


  usePushNotification();

  return (
    <MyDiv>
      <Grid className={toggleSidebar ? 'parent_grid_toggle' : 'parent_grid'}>
        <GridItem className="sidebar_grid">
          <Sidebar toggleSidebar={toggleSidebar} handleSidePanel={handleSidePanel} activePortal={isActive} />
        </GridItem>
        <GridItem className={toggleSidebar ? 'children_grid_toggle' : 'children_grid'}>
          <Flex alignItems='center' justifyContent='space-between' ml={8} >
            <Flex alignItems='center' columnGap={6} >
              {hasPermission("Recruitment") ? (
                <>
                  <CustomButton title="Hrlense Portal" className={`${isActive === 'hrlense' ? 'active-header-action' : 'header-action'} font-poppins text_medium text_lg`} onClick={() => handleToggle('hrlense')} />
                  <CustomButton title="Recruitment Portal" className={`${isActive === 'Recruitment' ? 'active-header-action' : 'header-action'} font-poppins text_medium text_lg`} onClick={() => handleToggle('Recruitment')} />
                  {/* <CustomButton title="Consumer Portal" className={`${isActive === "consumer" ? "active-header-action" : "header-action"} font-poppins text_medium text_lg`} onClick={() => handleToggle("consumer")} /> */}
                  <CustomButton title="Idea Management" className={`header-action font-poppins text_medium text_lg`} onClick={() => openIdeaManagement()} />
                </>
              ) :
                (
                  <>
                    <CustomButton title="Idea Management" className={`active-header-action font-poppins text_medium text_lg`} onClick={() => openIdeaManagement()} />
                  </>
                )
              }

            </Flex>
            <NavBar />
          </Flex>
          <Box mt={4} className='inner-children'>
            {props.children}
          </Box>
        </GridItem>
      </Grid>
      {reminderMeeting && (
        <MeetingReminderPopup meeting={reminderMeeting} onDismiss={dismissReminder} />
      )}
      {resignationNotification && (
        <ResignationNotificationPopup notification={resignationNotification} onDismiss={dismissResignationNotification} />
      )}
      {assetNotification && (
        <AssetNotificationPopup
          notification={assetNotification}
          onDismiss={dismissAssetNotification}
          bottom={resignationNotification ? '340px' : '160px'}
        />
      )}

    </MyDiv>

  )
}

export default AppLayout
